<div class="modal-backdrop" (click)="closeModal()">
  <form #giftCardForm="ngForm" class="modal" (click)="$event.stopPropagation()" (ngSubmit)="submit(giftCardForm)"
    novalidate>
    <div class="modal-header">
      <div>
        <span class="eyebrow">TRAVEL GIFT</span>
        <h2>Buy a gift voucher</h2>
        <p>Choose an amount and tell us where to send it.</p>
      </div>

      <button type="button" class="close-button" (click)="closeModal()" aria-label="Close">
        ×
      </button>
    </div>

    <div class="modal-body">
      <section class="form-section">
        <div class="field">
          <label for="giftCardName">Gift card name</label>
          <input #giftCardName="ngModel" id="giftCardName" name="giftCardName" type="text"
            [(ngModel)]="giftCard.name" placeholder="e.g. Birthday trip for Anna" maxlength="100"
            pattern=".*\S.*" required />
          @if (giftCardName.invalid && (giftCardName.touched || giftCardForm.submitted)) {
          <small>Please enter a gift card name.</small>
          }
        </div>
      </section>
      <section class="form-section">
        <label class="section-label">Voucher amount</label>
        <div class="amount-grid">
          @for (amount of amounts; track amount) {
          <button type="button" class="amount-button" [class.selected]="giftCard.amount === amount"
            [attr.aria-pressed]="giftCard.amount === amount" (click)="selectAmount(amount)">
            €{{ amount }}
          </button>
          }
        </div>
        <div class="custom-amount">
          <div class="custom-amount-heading">
            <label for="customAmount">Or enter a custom amount</label>
            <span>€25–€500</span>
          </div>

          <div class="currency-input" [class.invalid]="customAmount.invalid && customAmount.touched">
            <span aria-hidden="true">€</span>
            <input #customAmount="ngModel" id="customAmount" name="customAmount" type="number" inputmode="decimal"
              [(ngModel)]="giftCard.amount" min="25" max="500" step="5" placeholder="70"
              aria-describedby="customAmountHint" required />
          </div>

          <small id="customAmountHint" [class.error]="customAmount.invalid && customAmount.touched">
            @if (customAmount.invalid && customAmount.touched) {
            Enter an amount between €25 and €500.
            } @else {
            Choose any amount in €5 increments.
            }
          </small>
        </div>
      </section>

      <section class="form-section">
        <div class="section-title">
          <span>01</span>
          <h3>Your details</h3>
        </div>

        <div class="form-grid">
          <div class="field">
            <label for="buyerName">Your name</label>
            <input #buyerName="ngModel" id="buyerName" name="buyerName" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerName" placeholder="John Doe" autocomplete="name" maxlength="100"
              required />
            @if (buyerName.invalid && buyerName.touched) {
            <small>Please enter your name.</small>
            }
          </div>

          <div class="field">
            <label for="buyerEmail">Your email</label>
            <input #buyerEmail="ngModel" id="buyerEmail" name="buyerEmail" type="email"
              [(ngModel)]="giftCard.contactDetails.buyerEmail" placeholder="john@example.com" autocomplete="email" email
              required />
            @if (buyerEmail.invalid && buyerEmail.touched) {
            <small>Please enter a valid email address.</small>
            }
          </div>

          <div class="field">
            <label for="buyerPhone">Phone number</label>
            <input #buyerPhone="ngModel" id="buyerPhone" name="buyerPhone" type="tel"
              [(ngModel)]="giftCard.contactDetails.buyerPhone" placeholder="+49 123 456789"
              autocomplete="section-buyer tel" minlength="6" maxlength="25" required />
            @if (buyerPhone.invalid && buyerPhone.touched) {
            <small>Please enter your phone number.</small>
            }
          </div>

          <div class="field">
            <label for="buyerCountry">Country</label>
            <input #buyerCountry="ngModel" id="buyerCountry" name="buyerCountry" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerCountry" placeholder="Germany"
              autocomplete="section-buyer country-name" maxlength="100" />
            <!-- @if (buyerCountry.invalid && buyerCountry.touched) {
            <small>Please enter your country.</small>
            } -->
          </div>

          <div class="field">
            <label for="buyerStreet">Street</label>
            <input #buyerStreet="ngModel" id="buyerStreet" name="buyerStreet" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerStreet" placeholder="Main Street"
              autocomplete="section-buyer address-line1" maxlength="100" />
            <!-- @if (buyerStreet.invalid && buyerStreet.touched) {
            <small>Please enter your street.</small>
            } -->
          </div>

          <div class="field">
            <label for="buyerHouseNumber">House number</label>
            <input #buyerHouseNumber="ngModel" id="buyerHouseNumber" name="buyerHouseNumber" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerHouseNumber" placeholder="12A"
              autocomplete="section-buyer address-line2" maxlength="20" />
            <!-- @if (buyerHouseNumber.invalid && buyerHouseNumber.touched) {
            <small>Please enter your house number.</small>
            } -->
          </div>

          <div class="field">
            <label for="buyerPostalCode">Postal / PIN code</label>
            <input #buyerPostalCode="ngModel" id="buyerPostalCode" name="buyerPostalCode" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerPostalCode" placeholder="10115"
              autocomplete="section-buyer postal-code" maxlength="20" />
            <!-- @if (buyerPostalCode.invalid && buyerPostalCode.touched) {
            <small>Please enter your postal or PIN code.</small>
            } -->
          </div>

          <div class="field">
            <label for="buyerCity">City</label>
            <input #buyerCity="ngModel" id="buyerCity" name="buyerCity" type="text"
              [(ngModel)]="giftCard.contactDetails.buyerCity" placeholder="Berlin"
              autocomplete="section-buyer address-level2" maxlength="100" />
            <!-- @if (buyerCity.invalid && buyerCity.touched) {
            <small>Please enter your city.</small>
            } -->
          </div>
        </div>
      </section>


      <section class="form-section">
        <div class="section-title">
          <span>02</span>
          <h3>Recipient details</h3>
        </div>

        <div class="form-grid">
          <div class="field">
            <label for="recipientName">Recipient name</label>
            <input #recipientName="ngModel" id="recipientName" name="recipientName" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientName" placeholder="Jane Doe" autocomplete="name"
              maxlength="100" required />
            @if (recipientName.invalid && recipientName.touched) {
            <small>Please enter the recipient's name.</small>
            }
          </div>

          <div class="field">
            <label for="recipientEmail">Recipient email</label>
            <input #recipientEmail="ngModel" id="recipientEmail" name="recipientEmail" type="email"
              [(ngModel)]="giftCard.contactDetails.recipientEmail" placeholder="jane@example.com" autocomplete="email"
              email required />
            @if (recipientEmail.invalid && recipientEmail.touched) {
            <small>Please enter a valid recipient email address.</small>
            }
          </div>

          <div class="field">
            <label for="recipientPhone">Recipient phone number</label>
            <input #recipientPhone="ngModel" id="recipientPhone" name="recipientPhone" type="tel"
              [(ngModel)]="giftCard.contactDetails.recipientPhone" placeholder="+49 123 456789"
              autocomplete="section-recipient tel" minlength="6" maxlength="25" required />
            @if (recipientPhone.invalid && recipientPhone.touched) {
            <small>Please enter the recipient's phone number.</small>
            }
          </div>

          <div class="field">
            <label for="recipientCountry">Recipient country</label>
            <input #recipientCountry="ngModel" id="recipientCountry" name="recipientCountry" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientCountry" placeholder="Germany"
              autocomplete="section-recipient country-name" maxlength="100" />
            <!-- @if (recipientCountry.invalid && recipientCountry.touched) {
            <small>Please enter the recipient's country.</small>
            } -->
          </div>

          <div class="field">
            <label for="recipientStreet">Recipient street</label>
            <input #recipientStreet="ngModel" id="recipientStreet" name="recipientStreet" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientStreet" placeholder="Main Street"
              autocomplete="section-recipient address-line1" maxlength="100" />
            <!-- @if (recipientStreet.invalid && recipientStreet.touched) {
            <small>Please enter the recipient's street.</small>
            } -->
          </div>

          <div class="field">
            <label for="recipientHouseNumber">Recipient house number</label>
            <input #recipientHouseNumber="ngModel" id="recipientHouseNumber" name="recipientHouseNumber" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientHouseNumber" placeholder="12A"
              autocomplete="section-recipient address-line2" maxlength="20" />
            <!-- @if (recipientHouseNumber.invalid && recipientHouseNumber.touched) {
            <small>Please enter the recipient's house number.</small>
            } -->
          </div>

          <div class="field">
            <label for="recipientPostalCode">Recipient postal / PIN code</label>
            <input #recipientPostalCode="ngModel" id="recipientPostalCode" name="recipientPostalCode" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientPostalCode" placeholder="10115"
              autocomplete="section-recipient postal-code" maxlength="20" />
            <!-- @if (recipientPostalCode.invalid && recipientPostalCode.touched) {
            <small>Please enter the recipient's postal or PIN code.</small>
            } -->
          </div>

          <div class="field">
            <label for="recipientCity">Recipient city</label>
            <input #recipientCity="ngModel" id="recipientCity" name="recipientCity" type="text"
              [(ngModel)]="giftCard.contactDetails.recipientCity" placeholder="Berlin"
              autocomplete="section-recipient address-level2" maxlength="100" />
            <!-- @if (recipientCity.invalid && recipientCity.touched) {
            <small>Please enter the recipient's city.</small>
            } -->
          </div>
        </div>
      </section>

      <section class="form-section">
        <div class="quantity-row">
          <div>
            <label class="section-label">Quantity</label>
            <span class="field-hint">Number of vouchers</span>
          </div>

          <div class="quantity-control">
            <button type="button" (click)="decreaseQuantity()" aria-label="Decrease quantity">−</button>
            <span>{{ giftCard.quantity }}</span>
            <button type="button" (click)="increaseQuantity()" aria-label="Increase quantity">+</button>
          </div>
        </div>
      </section>

      <section class="form-section">
        <div class="field">
          <label for="message">
            Personal message
            <span>Optional</span>
          </label>
          <textarea id="message" name="message" [(ngModel)]="giftCard.message"
            placeholder="Enjoy your next adventure..." maxlength="300" rows="3"></textarea>
        </div>
      </section>
    </div>

    <div class="modal-footer">
      <div class="total">
        <span>Total</span>
        <strong>€{{ total }}</strong>
      </div>

      <button type="submit" class="cart-button">
        Buy
        <span>→</span>
      </button>
    </div>
  </form>
</div>